module.exports = __webpack_public_path__ + "img/capacitor-blue.104ffcac.png";